

























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'

@Component
export default class ColumnLastUpdate extends Vue {
    @Prop({ required: true }) referral!: Referral
    @Prop({ type: String, default: '#00A389' }) readonly color!: string

    get routeToOneContactDetail() {
        return {
            name: 'one_contact_detail',
            params: {
                contactId: this.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    get routeToTasksDetail() {
        return {
            name: 'tasks_detail',
            params: {
                referralId: this.referral.id,
                contactId: this.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }
}
